import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { AuthContext } from '../../../App/App';
import { WhatsappContext } from './Whatsapp';
import { ContentBodyContext } from '../MainContent';
import jwt from 'jwt-decode'

function ChatModalStatus() {
    const { stateContentBody, dispatchContentBody } = useContext(ContentBodyContext);
    const { stateWhatsApp, dispatchWhatsApp } = useContext(WhatsappContext);
    const { stateAuth, dispatchAuth } = useContext(AuthContext);

    //save data client and category
    const stateForm = {
        client: '',
        category: '',
        errCaretory: null,
        errClient: null,
        isSubmitting: false
    }
    const [dataForm, setDataForm] = useState(stateForm)

    const handleStatusClick = () => {
        setDataForm(stateForm)

        setRenderCategory(initialRenderCategory)

        dispatchWhatsApp({
            type: "MODALSTATUS",
            modalstatus: {
                status: false,
            }
        })
    }

    const handleOptionChange = (event) => {
        event.preventDefault()
        setDataForm({
            ...dataForm,
            [event.target.name]: event.target.value
        })
    }

    //render  category
    const initialRenderCategory = {
        status: false,
        event: null,
        renderStatus: false,
        renderClient: (
            <select name="client" id="client" className="form-control form-select ml-0 mr-sm-2" required autoFocus onChange={handleOptionChange}   >
                <option value="">Choose Client </option>
            </select>
        ),
        renderCategory: (
            <select name="category" id="category" className="form-control form-select ml-0 mr-sm-2" autoFocus >
                <option value="">Choose Category</option>
            </select>
        )
    }
    const [renderCategory, setRenderCategory] = useState(initialRenderCategory)

    useEffect(() => {
        if (stateWhatsApp.chatcategory.client != '') {
            let menu = [<option key={null} defaultValue value="">Choose Client</option>]
            stateWhatsApp.chatcategory.client.map((cli) => {
                menu.push(<option key={cli.role_id} value={cli.role_id}>{cli.client}</option>)
            })

            setRenderCategory({
                ...renderCategory,
                renderClient: (
                    <select name="client" id="client" className="form-control form-select ml-0 mr-sm-2" required autoFocus onChange={handleOptionChange}>
                        {menu}
                    </select>
                )
            })
        }
    }, [stateWhatsApp.chatcategory])

    useEffect(() => {
        if (dataForm.client != '') {
            setRenderCategory({
                ...renderCategory,
                renderCategory: (
                    <select name="category" id="category" className="form-control form-select ml-0 mr-sm-2" required autoFocus onChange={handleOptionChange}>
                        <option value="">Choose Category</option>
                        {stateWhatsApp.chatcategory.category.map(cat =>
                            cat.role == dataForm.client ? (<option key={cat.id} value={cat.id}>{cat.category}</option>) : <Fragment />)
                        }
                    </select>
                )
            })
        }
    }, [dataForm.client])

    const handleStatusClose = (event) => {
        event.preventDefault()
        if (dataForm.client == '') {
            setDataForm({
                ...dataForm,
                errClient: "*Choose client type."
            })

        } else if (dataForm.category == '') {
            setDataForm({
                ...dataForm,
                errCaretory: "*Choose Chat Category."
            })
        } else {
            //send a close message
            stateContentBody.socket.emit('whatsapp-chat', {
                id: jwt(localStorage.getItem('token-helpdesk-umy')).work_unit_id,
                token: localStorage.getItem('token-helpdesk-umy'),
                body: {
                    action: 'close',
                    file: null,
                    receiver: stateWhatsApp.chats.find(chat => chat.id == stateWhatsApp.active).phone,
                    message: "Sesi percakapan telah diakhiri oleh Admin, terima kasih telah menggunakan layanan kami.\n\nThe conversation session has been ended by the Admin, thank you for using our services.\n\n~autoreply by system",
                }
            })
        }
    }

    useEffect(() => {
        if (stateWhatsApp.trigger.status == 'success' && stateWhatsApp.trigger.message == 'whatsapp-chat-close' && stateWhatsApp.trigger.res.data.parentID == stateWhatsApp.active) {
            //update status
            stateContentBody.socket.emit('whatsapp-status', {
                id: jwt(localStorage.getItem('token-helpdesk-umy')).work_unit_id,
                token: localStorage.getItem('token-helpdesk-umy'),
                action: 'done',
                data: {
                    status_id: 3,
                    chat_id: stateWhatsApp.active,
                    client: dataForm.client,
                    category: dataForm.category,
                    user: stateWhatsApp.chats.find(data => data.id == stateWhatsApp.active)
                }
            })
            //reset active chat
            dispatchWhatsApp({
                type: "ACTIVE",
                active: null
            })
        } else if (stateWhatsApp.trigger.message == 'whatsapp-status' && stateWhatsApp.trigger.status == 'success' && stateWhatsApp.trigger.res.action == 'done') {

            //reset category
            dispatchWhatsApp({
                type: "CHATCATEGORY",
                chatcategory: { category: '', client: '' },
            })

            handleStatusClick()
        }
    }, [stateWhatsApp.trigger])


    useEffect(() => {
        //reset  selected data while load
        if (stateWhatsApp.modalstatus.status == true) {
            setDataForm(stateForm)
        }
    }, [stateWhatsApp.modalstatus])

    //render modal view
    const [renderModal, setRenderModal] = useState(<Fragment />)
    useEffect(() => {
        if (stateWhatsApp.modalstatus.status == true) {
            setRenderModal(
                <Fragment>
                    <Modal isOpen={stateWhatsApp.modalstatus.status} className="modal-dialog" backdrop={true} keyboard={true} >
                        <ModalHeader toggle={handleStatusClick} charCode={<i className="fas fa-times-circle" style={{ fontSize: '20px' }}></i>}>Close Conversation</ModalHeader>
                        <ModalBody>
                            <div className="form-group">
                                <label htmlFor="client">Choose Client Type </label>
                                {renderCategory.renderClient}
                                {(dataForm.errClient != null ? <small style={{ color: 'red' }}>{dataForm.errClient}</small> : '')}
                            </div>
                            <div className="form-group">
                                <label htmlFor="category">Choose Category</label>
                                {renderCategory.renderCategory}
                                {(dataForm.errCaretory != null ? <small style={{ color: 'red' }}>{dataForm.errCaretory}</small> : '')}
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={handleStatusClose} style={{ textTransform: 'capitalize' }} >{dataForm.isSubmitting ? '...Submitting' : 'Submit'}</Button>
                            <Button color="secondary" onClick={handleStatusClick} style={{ textTransform: 'capitalize' }} >Cancel</Button>
                        </ModalFooter>
                    </Modal>
                </Fragment>
            )
        } else {
            setRenderModal(<Fragment />)
        }
    }, [stateWhatsApp.modalstatus, dataForm, renderCategory])

    return (
        renderModal
    )
}

export default ChatModalStatus
